import { useContext, useMemo } from 'react';
import AuthContext from '../context/AuthContext';

export const PLANS = {
    ENTREPRENEUR: 'entrepreneur',
    GROWTH: 'growth',
    BUSINESS_NETWORK: 'business_network'
};

const usePlan = () => {
    const { business } = useContext(AuthContext);

    const planName = business?.plan_name;

    const permissions = useMemo(() => {
        const isGrowth = planName === PLANS.GROWTH;
        const isBusinessNetwork = planName === PLANS.BUSINESS_NETWORK;

        // Entrepreneur (Basic) is the default/lowest tier
        // Standard stats are for Growth and Business Network
        const canViewStandardStats = isGrowth || isBusinessNetwork;

        // Advanced stats are only for Business Network
        const canViewAdvancedStats = isBusinessNetwork;

        return {
            canViewStandardStats,
            canViewAdvancedStats,
            isBasic: !canViewStandardStats,
            isStandard: isGrowth,
            isAdvanced: isBusinessNetwork,
            planName
        };
    }, [planName]);

    return permissions;
};

export default usePlan;
